import _ from 'lodash';

/**
 * Enrollment/consent is complete when every subject-master step has been submitted.
 * Any status other than Pending counts (e.g. Completed, Verification_Pending,
 * External_Verification_Pending) — verification may still be in progress.
 */
export const isEnrollmentCompleted = (enrollmentStepStatus) => {
  if (!enrollmentStepStatus?.length) {
    return false;
  }
  return enrollmentStepStatus.every((step) => step.status !== 'Pending');
};

/**
 * First CRF visit step that is Pending and eligible for booking (prior steps not Pending).
 * Matches publishSlot.jsx subject eligibility rules.
 */
export const getEligibleVisitStep = (crfStepStatus) => {
  if (!crfStepStatus?.length) {
    return null;
  }
  const orderedSteps = _.sortBy(crfStepStatus, 'order');
  for (let i = 0; i < orderedSteps.length; i++) {
    const step = orderedSteps[i];
    if (step.status !== 'Pending') {
      continue;
    }
    if (i === 0) {
      return step;
    }
    if (orderedSteps[i - 1].status !== 'Pending') {
      return step;
    }
  }
  return null;
};
